<template>
    <div class="chat-top-message" @click.stop="onClickMessage">
       <div v-if="canManageTop" class="close" title="取消置顶" @click.stop="onClose"><i class="el-icon-close"></i></div>
        <div class="title">置顶消息: </div>
        <div class="marquee-container">
            <div class="marquee-wrapper" ref="marqueeWrapper">
                <div class="marquee-content" v-html="content" ></div>
   
            </div>
			
        </div>
		
		
		 
    </div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

export default {
    name: "chatTopMessage",
    components: { HeadImage },
    props: {
        group: {
            type: Object
        },
        groupMembers: {
            type: Array
        },
        msgInfo: {
            type: Object,
            required: true
        },
        headImage: {
            type: String,
            default: ''
        },
        showName: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            animationKey: null
        }
    },
    methods: {
        onClose() {
            this.removeTopMessage();
        },
        onClickMessage() {
            // 定位消息
            this.$emit("locate", this.msgInfo);
        },
        removeTopMessage() {
            this.$confirm('将在当前群聊的所有成员中取消此置顶消息，确认取消？', '取消置顶', {
                confirmButtonText: '取消置顶',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit('remove-top')
            });
        },
        hideTopMessage() {
            this.$emit('hide-top')
        },
        
        // 计算并设置动画持续时间
        setupMarqueeAnimation() {
            this.$nextTick(() => {
                const container = this.$el.querySelector('.marquee-container');
                const wrapper = this.$refs.marqueeWrapper;
                if (!container || !wrapper) return;
                
                // 获取容器宽度
                const containerWidth = container.offsetWidth;
                
                // 获取单个内容元素的宽度
                const content = wrapper.querySelector('.marquee-content:not(.clone)');
                const contentWidth = content.offsetWidth;
                
                // 设置滚动速度：50像素/秒
                const scrollSpeed = 50;
                
                // 只有当内容宽度大于容器宽度时才启动滚动动画
                if (contentWidth > containerWidth) {
                    // 设置动画样式
                    wrapper.style.animationDuration = `10s`;
                    wrapper.style.animationPlayState = 'running';
                    wrapper.style.transform = 'translateX(0)'; // 重置位置
                } else {
                    // 停止动画
                    wrapper.style.animationPlayState = 'paused';
                    wrapper.style.transform = 'translateX(0)'; // 重置到起始位置
                }
            });
        }
    },
    mounted() {
        this.setupMarqueeAnimation();
    },
    updated() {
        this.setupMarqueeAnimation();
    },
    computed: {
        content() {
            let content = "不支持的消息类型"
            if (this.msgInfo.type == this.$enums.MESSAGE_TYPE.IMAGE) {
                content = "[图片]";
            } else if (this.msgInfo.type == this.$enums.MESSAGE_TYPE.VIDEO) {
                content = "[视频]";
            } else if (this.msgInfo.type == this.$enums.MESSAGE_TYPE.FILE) {
                content = "[文件] " + JSON.parse(this.msgInfo.content).name;
            } else if (this.msgInfo.type == this.$enums.MESSAGE_TYPE.AUDIO) {
                content = "[语音] " + JSON.parse(this.msgInfo.content).duration + '"';
            } else if (this.msgInfo.type == this.$enums.MESSAGE_TYPE.USER_CARD) {
                content = "[个人名片] " + JSON.parse(this.msgInfo.content).nickName;
            } else if (this.msgInfo.type == this.$enums.MESSAGE_TYPE.GROUP_CARD) {
                content = "[群名片] " + JSON.parse(this.msgInfo.content).groupName;
            } else if (this.msgInfo.type == this.$enums.MESSAGE_TYPE.TEXT) {
                content = this.$emo.transform(this.$str.html2Escape(this.msgInfo.content), 'emoji-normal');
            }
            return content;
        },
        canManageTop() {
            return this.isOwner || this.isManager;
        },
        isOwner() {
            const mine = this.userStore.userInfo || {};
            const ownerId = this.group?.ownerId || this.group?.ownerAccountId;
            return [mine.id, mine.imAccid, mine.accountId, mine.userName, this.$yunxinIM?.currentAccount]
                .filter(Boolean)
                .some(id => String(id) === String(ownerId || ''));
        },
        isManager() {
            const mine = this.userStore.userInfo || {};
            const mineIds = [mine.id, mine.imAccid, mine.accountId, mine.userName, this.$yunxinIM?.currentAccount]
                .filter(Boolean)
                .map(id => String(id));
            let m = (this.groupMembers || []).find(member => {
                return [member.userId, member.id, member.accountId, member.imAccid]
                    .some(id => mineIds.includes(String(id || '')));
            });
            return !!(m && (m.isManager || Number(m.role) === 2));
        }
    }
}
</script>

<style scoped lang="scss">
.chat-top-message {
    width: 100%;
    position: fixed;
	top:100px;
    z-index: 1;
    margin: 0 2px;
    display: flex;
    background: #DCEBFD;
    padding: 10px 15px;
    align-items: center;
    border-radius: 0px;
    max-width: 100%;
    box-sizing: border-box;

    .title {
        font-size: var(--im-font-size-large);
        color: #666;
        flex-shrink: 0;
        white-space: nowrap;
    }

    .close {
        margin-left: 10px;
        width: 30px;
        cursor: pointer;
        flex-shrink: 0;
    }
    
    .marquee-container {
        flex: 1;
        height: 25px;
        overflow: hidden;
        position: relative;
        margin-left: 10px;
    }
    
    .marquee-wrapper {
        display: flex;
        height: 100%;
        align-items: center;
        animation-name: marquee;
        animation-timing-function: linear; /* 匀速动画 */
        animation-iteration-count: infinite;
        animation-play-state: paused; /* 初始状态为暂停 */
    }
    
    .marquee-content {
        font-size: var(--im-font-size-large);
        color: #666;
        white-space: nowrap;
        flex-shrink: 0;
        cursor: pointer;
    }
    
    /* 为克隆的内容添加一些间距 */
    .marquee-content.clone {
        margin-left: 20px; /* 两个内容块之间的间距 */
    }
}

/* 定义匀速滚动的关键帧动画 */
@keyframes marquee {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%); /* 移动距离为总宽度的一半 */
    }
}
</style>
